import { defaultPage } from "@/assets/cannotAccessList";

export default {
   state: {
      title: "",
      message: "",
      isError: false,
      showDialog: false,
      returnLink: null,
      userType: '',
      messageParams: {},
      confirmAlert: {
         title: "",
         message: "",
         isDelete: false,
         confirmBtnText: "confirm",
         cancelBtnText: "cancel",
      }
   },
   getters: {
      confirmAlert: state => state.confirmAlert
   },
   actions: {
      showAlert: ({ commit }, { title, message, isError, returnLink, userType, messageParams }) => {
         const obj = {
            title: "",
            message: "",
            isError: false,
            returnLink: returnLink || null,
            messageParams: messageParams || {}
         }
         if (message === 'noPermission') {
            if (userType !== undefined && userType !== null && userType !== '' && defaultPage[userType]) {
               obj['returnLink'] = { path: defaultPage[userType] };
            } else {
               obj['returnLink'] = { name: 'login' };
            }
         }

         switch (message) {
            case 'noData':
               obj['title'] = 'message.dataNotFound';
               obj['message'] = 'message.dataNotFoundMsg';
               obj['isError'] = true;
               break;
            case 'noPermission':
               obj['title'] = 'message.noPermission';
               obj['message'] = 'message.noPermissionMsg';
               obj['isError'] = true;
               break;
            default:
               obj['title'] = title;
               obj['message'] = message;
               obj['isError'] = isError;
               break;
         }
         commit('showAlert', obj);
      },
      closeAlert: ({ commit }) => {
         commit('closeAlert');
      },
      setConfirmAlert: ({ commit }, { title = "", message = "", isDelete = false, confirmBtnText = "confirm", cancelBtnText = "cancel" }) => {
         const obj = {
            title: title,
            message: message,
            confirmBtnText: confirmBtnText,
            cancelBtnText: cancelBtnText
         };
         if (isDelete) {
            obj['title'] = 'message.confirmToDeleteItem';
            obj['message'] = 'message.confirmToDeleteItemMessage';
         }
         commit('setConfirmAlert', obj);
      },
   },
   mutations: {
      showAlert: (state, { title, message, isError, returnLink, messageParams }) => {
         state.showDialog = true;
         state.title = title;
         state.message = message;
         state.isError = isError;
         state.returnLink = returnLink;
         state.messageParams = messageParams
      },
      closeAlert: (state) => {
         state.showDialog = false;
      },
      setConfirmAlert: (state, value) => {
         state.confirmAlert = value;
      }
   },
}
